<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title"><i class="fas fa-inbox"></i> {{entityName | translate}}</h4>
        <label class="float-right {{true ? '' : 'custom-div-hidden'}}">
            <a class="mr-2 ml-2 font-styles" href="javascript:"
               (click)="viewParams()"><i class="fa fa-eye"></i> {{ "BUTTON.VIEW-PARAMETERS" | translate }}</a>
        </label>
    </div>
    <div class="modal-body custom-height">
        <form [formGroup]="designEmailTemplateForm">
            <div class="row">
                <label for="subject" class="col-md-1 col-form-label"><b>{{ "LABEL.SUBJECT" | translate }}:</b></label>
                <div class="col-md-11 mb-1">
                    <div class="input-group br-6">
                        <input type="text"
                               id="subject"
                               class="form-control"
                               placeholder="{{ 'MESSAGE.SUBJECT' | translate }} {{'MESSAGE.BUSINESS-NAME'| translate}}"
                               formControlName="subject">
                    </div>
                </div>
            </div>
        </form>
        <email-editor (loaded)="editorLoaded()" (ready)="editorReady()" appearance="dark"></email-editor>
    </div>
    <!--  </div>-->
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-success" (click)="save()">
            <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
        </button>
        <button type="button" class="btn btn-outline-danger"
                (click)="close()">
            <i class="fa fa-times"></i> {{ "BUTTON.CANCEL" | translate }}
        </button>
    </div>
</div>
<app-loading *ngIf="loading"></app-loading>
